import React from 'react'
import { HomepageScreen } from '@mote/business'

export const Homepage = () => {
  return <HomepageScreen />
}
